import { AssociatedEids } from '@src/widgets/ActionPaths/AssociatedEids';

import { ActionPaths } from './ActionPaths';
import { AggregationView } from './AggregationView';
import { AssociatedEidCount } from './AssociatedEidCount';
import { Attribute } from './Attribute';
import { CountDistinctUntrustedCarrier } from './CountDistinctUntrustedCarrier';
import { CoverageStatus } from './CoverageStatus';
import { DataContainment } from './DataContainment';
import { Dates } from './Dates';
import { DobComparison } from './DobComparison';
import { DobUntrustedSources } from './DobUntrustedSources';
import { Eimp } from './Eimp';
import { EntityLastModified } from './EntityLastModified';
import { Events } from './Events';
import { EventTimeline } from './EventTimeline';
import { IreRecordDetail } from './IreRecordDetail';
import { IreRelatedEntities } from './IreRelatedEntities';
import { RemediationActions } from './RemediationActions';
import { RemediationEvents } from './RemediationEvents';
import { ReopenedEntityRisk } from './ReopenedEntityRisk';
import { RiskCode } from './RiskCode';
import { RiskCodes } from './RiskCodes';
import { RiskScore } from './RiskScore';
import { RiskScoreCombination } from './RiskScoreCombination';
import { SsnUntrustedSources } from './SsnUntrustedSources';
import { Tags } from './Tags';
import { TrustedRecordsCount } from './TrustedRecordsCount';
import { TrustedSourceCount } from './TrustedSourceCount';
import { TrustedSourceRecords } from './TrustedSourceRecords';
import { TrustedValueHistory } from './TrustedValueHistory';
import { UntrustedRecordsCount } from './UntrustedRecordsCount';
import { UntrustedSourceCount } from './UntrustedSourceCount';
import { UntrustedSourceRecords } from './UntrustedSourceRecords';
import { UntrustedSources } from './UntrustedSources';

export const ActionPathsWidget = ActionPaths;
export const AggregationViewWidget = AggregationView;
export const AssociatedEidCountWidget = AssociatedEidCount;
export const AssociatedEidsWidget = AssociatedEids;
export const AttributeWidget = Attribute;
export const CountDistinctUntrustedCarrierWidget = CountDistinctUntrustedCarrier;
export const CoverageStatusWidget = CoverageStatus;
export const DataContainmentWidget = DataContainment;
export const DatesWidget = Dates;
export const DobComparisonWidget = DobComparison;
export const DobUntrustedSourcesWidget = DobUntrustedSources;
export const EimpWidget = Eimp;
export const EntityLastModifiedWidget = EntityLastModified;
export const EventsWidget = Events;
export const EventTimelineWidget = EventTimeline;
export const IreRelatedEntitiesWidget = IreRelatedEntities;
export const IreRecordDetailWidget = IreRecordDetail;
export const RemediationActionsWidget = RemediationActions;
export const RemediationEventsWidget = RemediationEvents;
export const ReopenedEntityRiskWidget = ReopenedEntityRisk;
export const RiskCodesWidget = RiskCodes;
export const RiskCodeWidget = RiskCode;
export const RiskScoreCombinationWidget = RiskScoreCombination;
export const RiskScoreWidget = RiskScore;
export const SsnUntrustedSourcesWidget = SsnUntrustedSources;
export const TagsWidget = Tags;
export const TrustedRecordsCountWidget = TrustedRecordsCount;
export const TrustedSourceCountWidget = TrustedSourceCount;
export const TrustedSourceRecordsWidget = TrustedSourceRecords;
export const TrustedValueHistoryWidget = TrustedValueHistory;
export const UntrustedRecordsCountWidget = UntrustedRecordsCount;
export const UntrustedSourceCountWidget = UntrustedSourceCount;
export const UntrustedSourceRecordsWidget = UntrustedSourceRecords;
export const UntrustedSourcesWidget = UntrustedSources;

/**
 * Widgets
 *
 * @type {{ACTION_PATHS: ((function({handleSearch?: function(), riskRecord?: {}}): Element)|*), AGGREGATION_VIEW: ((function({aggregation?: {aggregationResults: [], researchAggregation: {chartTypes: [], dataTableColumnHeaders: {}, defaultChartType: string}}, criteria?: {entrance: {additional: [], commonCriteriaVersionsIds: [], commonIds: []}, exit: {additional: [], commonCriteriaVersionsIds: [], commonIds: []}}, view?: {description: string, id: string, name: string}}): Element)|*), ASSOCIATED_EID_COUNT: ((function({data?: {}}): Element)|*), ASSOCIATED_EIDS: ((function({actionPath?: {}}): Element)|*), ATTRIBUTE_TYPE_DOB: ((function({options?: {}, riskRecord?: {}}): Element)|*), ATTRIBUTE_TYPE_SSN: ((function({options?: {}, riskRecord?: {}}): Element)|*), COUNT_DISTINCT_UNTRUSTED_CARRIER: ((function({data?: {}}): Element)|*), COVERAGE_STATUS: ((function({riskRecord?: {}}): Element)|*), DATA_CONTAINMENT: ((function({assets: *, data: *}): Element)|*), DATES: ((function({riskRecord?: {}}): Element)|*), DOB_COMPARISON: ((function({data: *, riskCodes: *}): Element)|*), DOB_UNTRUSTED_SOURCES: ((function({data?: {}}): Element)|*), EIMP: ((function({riskRecord: *}): Element)|*), ENTITY_LAST_MODIFIED: ((function({data?: {}}): Element)|*), EVENT_TIMELINE: ((function({riskRecord: *}): Element)|*), EVENTS: ((function({assets: *, data: *}): Element)|*), IRE_RELATED_ENTITIES: ((function({ireRiskRecord?: {}}): *)|*), IRE_RECORD_DETAIL: *, REMEDIATION_ACTIONS: ((function({assignments?: [], initiativeType?: string, remediationType?: string, scopeCode?: string}): Element)|*), REMEDIATION_EVENTS: ((function({riskRecord?: {remediation: {remediationEvents: []}}}): Element)|*), REOPENED_ENTITY_RISK: ((function({data?: {}}): Element)|*), RISK_CODE: ((function({data?: {}, riskCodes?: []}): Element)|*), RISK_CODES: ((function({assets?: {}, data?: {}}): Element)|*), RISK_SCORE: ((function({data?: {}}): Element)|*), RISK_SCORE_COMBINATIONS: ((function({riskCodes?: [], data?: {data: {content: []}, defaultView: string, description: string, name: string, riskCodes: []}}): Element)|*), SSN_UNTRUSTED_SOURCES: ((function({data?: {}}): Element)|*), TAGS: ((function({assets?: {}, riskRecord?: {}}): Element)|*), TRUSTED_RECORDS_COUNT: ((function({data?: {}}): Element)|*), TRUSTED_SOURCE_COUNT: ((function({data?: {}}): Element)|*), TRUSTED_SOURCE_RECORDS: ((function({data?: {}}): Element)|*), TRUSTED_VALUE_HISTORY: ((function({riskRecord?: {}}): Element)|*), UNTRUSTED_RECORDS_COUNT: ((function({data?: {}}): Element)|*), UNTRUSTED_SOURCE_COUNT: ((function({data?: {}}): Element)|*), UNTRUSTED_SOURCE_RECORDS: ((function({data?: {}}): Element)|*), UNTRUSTED_SOURCES: ((function({data?: {}}): Element)|*)}}
 */
export const widgets = {
  ACTION_PATHS: ActionPathsWidget,
  AGGREGATION_VIEW: AggregationViewWidget,
  ASSOCIATED_EID_COUNT: AssociatedEidCountWidget,
  ASSOCIATED_EIDS: AssociatedEidsWidget,
  ATTRIBUTE_TYPE_DOB: AttributeWidget,
  ATTRIBUTE_TYPE_SSN: AttributeWidget,
  COUNT_DISTINCT_UNTRUSTED_CARRIER: CountDistinctUntrustedCarrierWidget,
  COVERAGE_STATUS: CoverageStatusWidget,
  DATA_CONTAINMENT: DataContainmentWidget,
  DATES: DatesWidget,
  DOB_COMPARISON: DobComparisonWidget,
  DOB_UNTRUSTED_SOURCES: DobUntrustedSourcesWidget,
  EIMP: EimpWidget,
  ENTITY_LAST_MODIFIED: EntityLastModifiedWidget,
  EVENT_TIMELINE: EventTimelineWidget,
  EVENTS: EventsWidget,
  IRE_RECORD_DETAIL: IreRecordDetailWidget,
  IRE_RELATED_ENTITIES: IreRelatedEntitiesWidget,
  REMEDIATION_ACTIONS: RemediationActionsWidget,
  REMEDIATION_EVENTS: RemediationEventsWidget,
  REOPENED_ENTITY_RISK: ReopenedEntityRiskWidget,
  RISK_CODE: RiskCodeWidget,
  RISK_CODES: RiskCodesWidget,
  RISK_SCORE: RiskScoreWidget,
  RISK_SCORE_COMBINATIONS: RiskScoreCombinationWidget,
  SSN_UNTRUSTED_SOURCES: SsnUntrustedSourcesWidget,
  TAGS: TagsWidget,
  TRUSTED_RECORDS_COUNT: TrustedRecordsCountWidget,
  TRUSTED_SOURCE_COUNT: TrustedSourceCountWidget,
  TRUSTED_SOURCE_RECORDS: TrustedSourceRecordsWidget,
  TRUSTED_VALUE_HISTORY: TrustedValueHistoryWidget,
  UNTRUSTED_RECORDS_COUNT: UntrustedRecordsCountWidget,
  UNTRUSTED_SOURCE_COUNT: UntrustedSourceCountWidget,
  UNTRUSTED_SOURCE_RECORDS: UntrustedSourceRecordsWidget,
  UNTRUSTED_SOURCES: UntrustedSourcesWidget,
};
